const COLLECTION_CATEGORIES = [
  { key: "documents", label: "Documents", primary: true },
  { key: "indexes", label: "Indexes", primary: true },
  { key: "sharding", label: "Sharding" },
  { key: "mappings", label: "Mappings" },
  { key: "schema", label: "Schema" }
];
const load = async (event) => {
  return {
    collection: event.params.collection,
    categories: COLLECTION_CATEGORIES,
    breadcrumbs: [
      ...(await event.parent()).breadcrumbs,
      { label: event.params.collection, path: `/${event.params.collection}/documents` }
    ]
  };
};
export {
  load
};
